<template>
  <el-date-picker
    v-model="selectVal"
    :type="type"
    v-bind="$attrs"
    v-on="$listeners"
    :value-format="valueFormat"
    :placeholder="placeholder"
    :picker-options="datePickerOptions"
    @change="setVal"
  >
  </el-date-picker>
</template>

<script>
import dayjs from 'dayjs';
export default {
  name: 'datePicker',
  components: {},
  props: {
    placeholder: {
      type: String,
      default: '请选择'
    },
    valueFormat: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    value: {
      type: [String, Array],
      default: () => ''
    },
    pickerOptions: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: () => 'date'
    }
  },
  data() {
    return {
      datePickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const date = dayjs().format('YYYY-MM-DD');
              picker.$emit('pick', date);
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
              picker.$emit('pick', date);
            }
          }
        ]
      }
    };
  },

  computed: {
    selectVal: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      }
    }
  },
  created() {
    if (this.type === 'date') {
      this.datePickerOptions = {
        ...this.datePickerOptions,
        ...this.pickerOptions
      };
    } else {
      this.datePickerOptions = {};
    }
  },
  methods: {
    setVal(val) {
      console.log(val);
      this.$emit('change', val);
    }
  }
};
</script>
<style lang="scss" scoped></style>
